import { WishlistApp } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.19.5/wishlist-app.js";

export const createApp = ({ settings, config, locale }) => {
  if (window.WishlistKing) {
    return;
  }

  const app = new WishlistApp({
    config,
    settings,
    locale,
    dependencies: [
      "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.19.5/components/wishlist.css",
      "//skm.be/cdn/shop/t/12/assets/wishlist-king-custom.css?v=22075234692076017371753708851",
      "//skm.be/cdn/shop/t/12/assets/wishlist-king-components.js?v=96016734640993836071753708850",
    ],
  });

  initEvents(app);
  initComponents(app);

  return app;
};

const initComponents = ({ theme, routes }) => {
  // Header link
  theme.watch(
    {
      selector: ".logo-area__right .cart-link",
    },
    (target) => {
      target.insertBefore(
        theme.createComponent("wishlist-link", {
          props: {
            layout: "icon-and-text",
            alignment: "center",
          },
        })
      );
    }
  );

  // Grid items

  theme.watch(
    {
      selector: `.image-cont .product-link[href*="/products/"]`,
      pageType: ["home", "product", "collection"],
    },
    (target) => {
      if (!target.element.id) target.element.id = `ref_${Math.round(Date.now() * Math.random())}`;
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            alignment: "center",
            floating: {
              reference: `#${target.element.id}`,
              position: {
                placement: "top-end",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );
  
  theme.watch(
    {
      selector: `.snize-view-link[href*="/products/"]`,
      pageType: ["home", "product", "collection"],
    },
    (target) => {
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            alignment: "center",
            floating: {
              reference: target,
              position: {
                placement: "top-end",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );

  // Product page
  theme.watch(
    {
      selector: `.buy-buttons-row`,
      pageType: ["product"],
    },
    (target) => {
      target.append(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(document.location.href),
            variantId: theme.getVariantId(document.location.href),
          },
          props: {
            layout: "icon-and-text",
            alignment: "left",
            fullWidth: true,
            outline: false,
          },
        })
      );
    }
  );

  // Wishlist page
  theme.watch(
    {
      selector: "#wishlist-page",
    },
    (target) => {
      target.replace(
        theme.createComponent("wishlist-page", {
          dataset: {
            wishlistId: theme.getWishlistId(window.location.pathname),
          },
        })
      );
    }
  );
};

const initEvents = (app) => {
  app.events.subscribe("wk:wishlist:add-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:add-all-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:login-required", (event) => {
    const ignoreActions = ["wishlist:private:load"];
    if (!ignoreActions.includes(event.data.action)) {
      window.location.href = app.routes.accountLoginUrl;
    }
  });
};
